import type { Service } from '../types'

export const services: Service[] = [
  {
    id: 'web-design',
    icon: '🎨',
    title: 'Web Design',
    description:
      'Stunning, user-centric interfaces that captivate audiences and drive engagement. We craft visual experiences that tell your brand story.',
    features: [
      'UI/UX Strategy',
      'Wireframing & Prototyping',
      'Responsive Design',
      'Design Systems',
      'Brand Identity Integration',
      'Accessibility Compliance',
    ],
    gradient: 'from-electric-blue via-purple-400 to-electric-purple',
  },
  {
    id: 'development',
    icon: '⚡',
    title: 'Web Development',
    description:
      'High-performance web applications built with modern frameworks. Fast, scalable, and maintainable code that powers your business.',
    features: [
      'React / Next.js / Vue',
      'Node.js & API Development',
      'Database Architecture',
      'Progressive Web Apps',
      'Performance Optimization',
      'CI/CD Pipeline Setup',
    ],
    gradient: 'from-electric-purple via-violet-500 to-pink-500',
  },
  {
    id: 'ecommerce',
    icon: '🛒',
    title: 'eCommerce Solutions',
    description:
      'Revenue-driven online stores with seamless checkout experiences. From Shopify to custom builds, we drive conversions.',
    features: [
      'Shopify / WooCommerce',
      'Custom Cart Solutions',
      'Payment Gateway Integration',
      'Inventory Management',
      'Conversion Optimization',
      'Multi-currency Support',
    ],
    gradient: 'from-amber-400 via-orange-500 to-red-500',
  },
  {
    id: 'seo',
    icon: '📈',
    title: 'SEO & Analytics',
    description:
      'Data-driven strategies that boost your visibility and organic traffic. We optimize every layer for search engine success.',
    features: [
      'Technical SEO Audit',
      'On-Page Optimization',
      'Content Strategy',
      'Link Building',
      'Analytics Setup & Tracking',
      'Performance Monitoring',
    ],
    gradient: 'from-emerald-400 via-teal-500 to-cyan-600',
  },
  {
    id: 'maintenance',
    icon: '🔧',
    title: 'Maintenance & Support',
    description:
      'Round-the-clock monitoring and updates to keep your site secure, fast, and bug-free. We handle the tech so you focus on business.',
    features: [
      'Security Updates',
      'Performance Monitoring',
      'Content Updates',
      'Backup & Recovery',
      'Uptime Monitoring',
      'Technical Support',
    ],
    gradient: 'from-sky-400 via-blue-500 to-indigo-600',
  },
  {
    id: 'branding',
    icon: '✨',
    title: 'Digital Branding',
    description:
      'Cohesive brand identities that resonate across all digital touchpoints. We build brands that leave lasting impressions.',
    features: [
      'Brand Strategy',
      'Visual Identity Design',
      'Logo & Iconography',
      'Brand Guidelines',
      'Social Media Assets',
      'Email Design',
    ],
    gradient: 'from-fuchsia-400 via-pink-500 to-rose-600',
  },
]
